class Exercise {
  constructor({
    id,
    exerciseName,
    exerciseType,
    laterality,
    measure,
    value,
    valueLeft,
    valueRight,
    sets = 1,
    deletedAt,
  }) {
    this.id           = id
    this.exerciseName = exerciseName
    this.exerciseType = exerciseType
    this.laterality   = laterality
    this.measure      = measure
    this.value        = value
    this.valueLeft    = valueLeft
    this.valueRight   = valueRight
    if (exerciseType !== "cardio") {
      this.sets       = sets ?? 1
    }
    this.deletedAt    = deletedAt
  }

}
export default Exercise
